import {useFormik} from 'formik';
import * as Yup from 'yup';
import {AxiosError} from 'axios';
import {CreateCategoryDTO, useCategories} from '../../../entities';
import {useSchemes} from '../../../shared';

interface UseAddCategoryFormProps {
  setOpen: (open: boolean) => void;
  initialGroupId?: string | null;
}

export const useAddCategoryForm = ({setOpen, initialGroupId = null}: UseAddCategoryFormProps) => {
  const {createCategoryMutation} = useCategories({}, {enableInfiniteQuery: false});
  const {nameSchema, orderSchema} = useSchemes();

  const onSubmit = async (values: CreateCategoryDTO) => {
    try {
      await createCategoryMutation.mutateAsync({
        ...values,
        categoryGroupId: values.categoryGroupId || null,
        imageUploadId: values.imageUploadId || null,
      });
      setOpen(false);
    } catch (error: any) {
      console.error(error);
    }
  };

  const formik = useFormik<CreateCategoryDTO>({
    initialValues: {
      name: '',
      order: 0,
      categoryGroupId: initialGroupId,
      imageUploadId: null,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: nameSchema,
      order: orderSchema,
      categoryGroupId: Yup.string().nullable(),
      imageUploadId: Yup.string().nullable(),
    }),
    onSubmit: onSubmit,
  });

  return {
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    setFieldValue: formik.setFieldValue,
    setFieldTouched: formik.setFieldTouched,
    handleChange: formik.handleChange,
    handleBlur: formik.handleBlur,
    resetForm: formik.resetForm,
    submitForm: formik.submitForm,
    isLoading: createCategoryMutation.isPending,
    submitError: createCategoryMutation.error
      ? (createCategoryMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
  };
};
